import { render, staticRenderFns } from "./404.vue?vue&type=template&id=451bc27c&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=451bc27c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451bc27c",
  null
  
)

export default component.exports